/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelProspectType.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/crm/prospect-type";

export class AutogenModelProspectType<RowType extends ModelRow> extends Endpoint<RowType, RowProspectTypeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowProspectType extends ModelRow<RowProspectTypeFields> {
	constructor(values?: Partial<RowProspectTypeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowProspectTypeFields {
	company_id: string;
	descr: string;
	id: string;
}

